import { css } from '@/styled-system/css';
import type { SystemStyleObject } from '@/styled-system/types';

// Shared base styles for all attachment card variants
const baseAttachmentCardStyles: SystemStyleObject = {
  alignItems: 'center',
  border: 'solid',
  borderColor: 'border.muted',
  borderWidth: '1px',
  display: 'flex',
  paddingBlock: 'tight',
  paddingLeft: 'default',
  paddingRight: 'tighter',
};

export const sidebarAttachmentCardStyles = css.raw({
  ...baseAttachmentCardStyles,
  alignSelf: 'stretch',
  borderRadius: '300',
});

export const getChatBubbleBorderRadius = (isMessageOwner: boolean): SystemStyleObject => ({
  borderBottomRightRadius: isMessageOwner ? '100' : '500',
  borderBottomLeftRadius: isMessageOwner ? '500' : '100',
});

const messageAttachmentCardBaseStyles = css.raw({
  ...baseAttachmentCardStyles,
  borderRadius: '500',
  marginBottom: 'tighter',
});

const messageOwnerAttachmentCardStyles = css.raw({
  ...messageAttachmentCardBaseStyles,
  borderBottomRightRadius: '100',
  borderBottomLeftRadius: '500',
});

const messageNonOwnerAttachmentCardStyles = css.raw({
  ...messageAttachmentCardBaseStyles,
  borderBottomRightRadius: '500',
  borderBottomLeftRadius: '100',
});

export function getAttachmentCardStyles(variant: 'sidebar' | 'message', isMessageOwner: boolean): SystemStyleObject {
  if (variant === 'sidebar') {
    return sidebarAttachmentCardStyles;
  }

  return isMessageOwner ? messageOwnerAttachmentCardStyles : messageNonOwnerAttachmentCardStyles;
}
